// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ypei","type":"styles_type__2HimH","choices":"styles_choices__1LnAf"};